function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#CBCBCB;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.1,21.9h6.2c1.2,1.4,3,2.2,5,2.2c3.7,0,6.6-3,6.6-6.6c0-2.2-1.1-4.2-2.7-5.3V6.8c0-2.7-2.2-4.9-4.9-4.9H6.1 C3.3,1.8,1.1,4,1.1,6.8v10.2C1.1,19.7,3.3,21.9,6.1,21.9L6.1,21.9z M2.8,6.8c0-1.8,1.5-3.2,3.2-3.2h10.2c1.8,0,3.2,1.5,3.2,3.2v4.4 c-0.7-0.2-1.5-0.4-2.2-0.4c-0.6,0-1.1,0.1-1.7,0.2H5.5v1.7h7.1c-0.5,0.5-0.9,1.1-1.3,1.7H5.5v1.7h5.2c-0.1,0.4-0.1,0.9-0.1,1.3 c0,1,0.2,1.9,0.6,2.7H6c-1.8,0-3.2-1.5-3.2-3.2L2.8,6.8L2.8,6.8z M11.4,17.5c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8 s-2.6,5.8-5.8,5.8C14,23.2,11.4,20.7,11.4,17.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,7.6h11.3v1.7H5.5V7.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,21.3c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0-0.5-0.2-0.5c-1.6-0.6-2.5-2.4-1.9-4.1c0.3-0.8,0.9-1.4,1.6-1.8 c0.8-0.3,1.6-0.4,2.4-0.1c0.9,0.3,1.6,1.1,1.9,2l-0.8,0l1.2,2.3l1.4-2.1l-0.9,0c-0.3-1.3-1.3-2.4-2.5-2.8c-2.1-0.8-4.4,0.3-5.1,2.4 c-0.8,2.1,0.3,4.4,2.4,5.1C15.9,21.3,16,21.3,16,21.3L16,21.3z"
}));

var SvgIcSubscriptionGrey = function SvgIcSubscriptionGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    width: 25,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSubscriptionGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_subscription_grey.f6d346ec.svg";
export { ForwardRef as ReactComponent };